export default __webpack_public_path__ + "static/media/user.125ae8ec.svg";